export const GROUPING_HISTORY_REQUEST = "GROUPING_HISTORY_REQUEST";
export const GROUPING_HISTORY_SUCCESS = "GROUPING_HISTORY_SUCCESS";
export const GROUPING_HISTORY_FAILED = "GROUPING_HISTORY_FAILED";
